<script>
import { computed, watch } from 'vue';

import { useI18n } from 'vue-i18n';

import {
  CalendarFullIcon,
  GridIcon,
  PieChartIcon,
} from '@thehotelsnetwork/icons/vue/linear';

import useSectionState from '@/state/useSectionState';
import useDebugState from '@/state/useDebugState';
import useUserState from '@/state/useUserState';

import { track } from '@/utils/analytics';

export default {
  setup() {
    const { t } = useI18n();
    const {
      sectionView,
      sectionHasCalendarView,
    } = useSectionState();
    const { isDebugActive } = useDebugState();
    const { isStrictlyDMOUser } = useUserState();

    const viewOptions = computed(() => [
      { value: 'charts', label: t('Charts'), icon: PieChartIcon },
      {
        value: 'calendar',
        label: t('Calendar'),
        icon: CalendarFullIcon,
        disabled: !sectionHasCalendarView.value,
      },
      { value: 'tables', label: t('Tables'), icon: GridIcon },
    ]);

    watch(sectionView, () => {
      track(`view - ${sectionView.value}`);
    });

    return {
      sectionView,
      sectionHasCalendarView,
      viewOptions,
      isDebugActive,
      isStrictlyDMOUser,
    };
  },
};
</script>
<template>
  <LpButtonGroup
    :key="sectionView"
    v-model="sectionView"
    :options="viewOptions"
  >
    <template #tooltip-calendar>
      {{ $t('These metrics don\'t relate to stay or browsing dates') }}
    </template>
  </LpButtonGroup>
</template>
